const windowMap = {}
window.addEventListener('message', event => {
    if (event.data?.type === 'oss-download-close') {
        const win = windowMap[event.data.t]
        if (win) {
            delete windowMap[event.data.t]
            try {
                win.close()
                // console.warn(`下载窗口关闭成功`)
            } catch (error) {
                // console.warn('下载窗口关闭失败:', error)
            }
        }
    }
})
export function saveWin(win, t) {
    windowMap[t] = win
    setTimeout(() => {
        if (windowMap[t]) {
            delete windowMap[t]
        }
    }, 60000 * 60)
}
